import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m13.5 22.5-2.929-2.344A1.64 1.64 0 0 1 10 18.48h0a1.637 1.637 0 0 1 2.321-1.067L13.5 18v-5.25a1.5 1.5 0 0 1 1.5-1.5h0a1.5 1.5 0 0 1 1.5 1.5v3l1.993.332A3 3 0 0 1 21 19.041V22.5M5.247 6h7.5m-7.5 3h7.5m-7.5 3h3.75"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.5 18H2.247a1.5 1.5 0 0 1-1.5-1.5V3a1.5 1.5 0 0 1 1.5-1.5h19.5a1.5 1.5 0 0 1 1.5 1.5v12m-4.5-13.5v9"
    }, null, -1)
  ]));
}
const computerDeviceMobileTabletTouch = { render };
export {
  computerDeviceMobileTabletTouch as default,
  render
};
//# sourceMappingURL=computer-device-mobile-tablet-touch.svg.js.map
